<template>
    <modal :show.sync=show modalClasses="medium-sized-modal">
        <h3 slot="header" class="mb-0 font-weight-500">Schedule Meeting</h3>
        <b-form ref="AddMeetingForm" role="form" @submit.prevent="submit()">
            <b-row>
                <!-- FIELD LEADS -->
                <!-- <b-col cols="12">
                    <b-form-group label="Lead">
                        <el-input
                            :value="leadData.name"
                            placeholder="Please input"
                            :disabled="true">
                        </el-input>
                    </b-form-group>
                </b-col> -->

                <!-- FIELD LEADS -->
                <b-col cols="12" md="12">
                    <b-form-group label="Lead">
                        <b-input-group >
                            <b-form-input :value="leadData.name" :disabled="true" size="md"></b-form-input>
                                <b-input-group-append size="md">
                                    <b-button variant="primary">
                                    <router-link :to="'/leadProfileDetails/'+leadData.lead_id" class="text-white">
                                        <span class="my-0 py-0">
                                            Detail
                                        </span>
                                    </router-link>
                                    </b-button>
                                </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <!-- FIELD ASSIGN TO
                <b-col cols="12">
                    <b-form-group label="Assign To">
                        <el-select v-model="new_meeting.assigned_to" filterable placeholder="Select">
                            <el-option
                            v-for="hub in hubName"
                            :key="hub.hub_id"
                            :label="hub.hub_name"
                            :value="hub.hub_id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col> -->

                <!-- FIELD TITLE -->
                <b-col cols="12">
                    <b-form-group label="Title">
                        <b-form-input
                            v-model="new_meeting.title"
                            type="text"
                            required
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <!-- FIELD DATE START -->
                <b-col cols="12" md="6">
                    <b-form-group label="Date Start">
                        <!-- <b-form-input
                        :value="startValue"
                        @input="updateStartValue"
                        type="datetime"
                        required
                        readonly
                        ></b-form-input> -->
                        <b-form-datepicker v-model="new_meeting.date_start" id="dateInput"></b-form-datepicker>
                    </b-form-group>
                </b-col>

                <!-- FIELD DATE END -->
                <b-col cols="12" md="6">
                    <b-form-group label="Date End">
                        <!-- <b-form-input
                        :value="endValue"
                        @input="updateEndValue"
                        type="datetime-local"
                        required
                        ></b-form-input> -->
                        <b-form-datepicker v-model="new_meeting.date_end"></b-form-datepicker>
                    </b-form-group>
                </b-col>

                <!-- FIELD TIME START -->
                <b-col cols="12" md="6">
                    <b-form-group label="Time Start">
                        <!-- <b-form-input
                        v-model="new_meeting.time_start"
                        type="time"
                        required 
                        ></b-form-input> -->

                        <!-- <b-form-timepicker v-model="new_meeting.time_start" id="timeInput"></b-form-timepicker> -->

                        <el-time-picker
                            v-model="new_meeting.time_start"
                            placeholder="Time Start"
                            format="HH:mm A"
                            value-format="HH:mm:ss"
                            >
                        </el-time-picker>

                        <!-- <el-time-picker
                            v-model="testtry"
                            placeholder="Time Start"
                            format="HH:mm:ss"
                            value-format="HH:mm A"
                            >
                        </el-time-picker> -->

                    </b-form-group>
                </b-col>
            
                <!-- FIELD TIME END -->
                <b-col cols="12" md="6">
                    <b-form-group label="Time End">
                        <!-- <b-form-input
                        :value="endValue"
                        @input="updateEndValue"
                        type="datetime-local"
                        required
                        ></b-form-input> -->

                        <!-- <b-form-timepicker v-model="new_meeting.time_end"></b-form-timepicker> -->

                        <el-time-picker
                            v-model="new_meeting.time_end"
                            placeholder="Time End"
                            format="HH:mm A"
                            value-format="HH:mm:ss"
                            >
                        </el-time-picker>

                    </b-form-group>
                </b-col>

                <!-- FIELD DESCRIPTION -->
                <b-col cols="12">
                    <b-form-group label="Description">
                        <b-form-input
                            v-model="new_meeting.description"
                            type="text"
                            required
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <!-- SUBMIT BUTTON -->
                <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button type="submit" class="w-100" variant="primary">Schedule</b-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { Select, Option, TimePicker } from 'element-ui'
import {
    helperFunctionMixin,
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import { EventBus } from '@/main'
import { mapActions } from 'pinia'
import { useLeadStore } from '@/stores/leadStore'

export default {
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    props:{
        show_schedule_meeting: Boolean,
        leadData: Object
    },
    data(){
        return {
            new_meeting: {
                assigned_to: "",
                title:"",
                description: "",
                date_start: "",
                date_end: "",
                time_start: "",
                time_end: "",
                status: "Scheduled",
                remark_meeting: "",
            },
            hubName: [],
        }
    },
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        [TimePicker.name]: TimePicker,
    },
    created(){
        
    },
    computed: {
        show: {
            get() {
                return  this.show_schedule_meeting;
            },
            set(newVal) {
                this.$emit('update:show_schedule_meeting', newVal);
            },
        },
    },
    methods: {
        ...mapActions(useLeadStore,['getLeadActivityLog']),
        fetchHub(){
            axios.get(services.hub + 'hubs', {headers: getHeader()})
            .then(res => {
                this.hubName = res.data.data
            })
            .catch(e => {
                this.isTableLoading = false
                // this.errorFunction(e)
            })
        },
        submit(){

            let form = new FormData()
            form.append('lead_id',this.leadData.lead_id)
            // form.append('hub_id',this.new_meeting.assigned_to)
            this.leadData.assign_to ? form.append('hub_id',this.leadData.hub.hub_id) : form.append('hub_id',this.new_call.assigned_to)
            form.append('reminder','5')
            form.append('subject',this.new_meeting.title)
            form.append('description',this.new_meeting.description)
            form.append('start_at',this.new_meeting.date_start)
            form.append('end_at',this.new_meeting.date_end)
            form.append('time_start',this.new_meeting.time_start)
            form.append('time_end',this.new_meeting.time_end)
            form.append('remark_meeting',this.new_meeting.remark_meeting)
            form.append('status',this.new_meeting.status)

            axios.post(services.lead + 'meeting', form, { headers: getHeader() })
                .then(res => {
                    this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Created.')
                    this.$emit('closeMeetingModal')
                    this.resetFormToNull(this.new_meeting)
                    EventBus.$emit('refresh-meeting-and-call')
                    // this.getLeadActivityLog(this.$route.params.lead_id)
                    this.getLeadActivityLog(this.leadData.lead_id)
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
    }
}
</script>